export default __webpack_public_path__ + "static/media/download.bd48d510.svg";